import React, { createContext, useContext, useMemo, useState } from "react";

import { WholeLifePlan, PlanCost } from "Utils/types";

import { useModal } from "Cobalt/Modal";

interface OpenEnrollmentModalProps {
  plan: WholeLifePlan;
  planCost: PlanCost;
}
interface WholeLifeContextProps {
  openEnrollmentModal: (props: OpenEnrollmentModalProps) => void;
  plan: WholeLifePlan | null;
  planCost: PlanCost | null;
  isShowing: boolean;
  hideEnrollmentModal: () => void;
}

const WholeLifeContext = createContext<WholeLifeContextProps>({
  openEnrollmentModal: () => {},
  plan: null,
  planCost: null,
  isShowing: false,
  hideEnrollmentModal: () => {},
});

interface OpenEnrollmentModalProps {
  plan: WholeLifePlan;
  planCost: PlanCost;
}
export const WholeLifeContextProvider = ({ children }) => {
  const { show, hide, isShowing } = useModal();
  const [_plan, _setPlan] = useState<WholeLifePlan | null>(null);
  const [_planCost, _setPlanCost] = useState<PlanCost | null>(null);
  const contextValue = useMemo(() => {
    const openEnrollmentModal = ({ plan, planCost }: OpenEnrollmentModalProps) => {
      _setPlan(plan);
      _setPlanCost(planCost);
      show();
    };
    const hideEnrollmentModal = () => {
      _setPlan(null);
      _setPlanCost(null);
      hide();
    };

    return { openEnrollmentModal, plan: _plan, planCost: _planCost, isShowing, hideEnrollmentModal };
  }, [_plan, _planCost, isShowing, show, hide]);

  return <WholeLifeContext.Provider value={contextValue}>{children}</WholeLifeContext.Provider>;
};

export const useWholeLifeContext = () => useContext(WholeLifeContext);
